function openSearch() {

    $('.search-handler').on('click', function(ev) {
        ev.preventDefault();
        $(this).parent().toggleClass('open');
    });
}

function searchFormSubmit(){
    $('.job-search').on('change', ' select', function(event) {
        $(this).closest('form').submit();
    });
}